module.exports = __webpack_public_path__ + "bg3.652bced4a78d5ed7cf26.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/pages/img/frontend-slider/bg3.jpg
// module id = ../../../../../src/assets/pages/img/frontend-slider/bg3.jpg
// module chunks = styles